export const ERR_NOT_FOUND = 'ERR_NOT_FOUND'
